"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var unavailable_exports = {};
__export(unavailable_exports, {
  ScreenCapture: () => ScreenCapture,
  usePreventScreenCapture: () => usePreventScreenCapture
});
module.exports = __toCommonJS(unavailable_exports);
var import_react = require("react");
var import_validate = require("./validate");
var import_validateCallback = require("../validateCallback");
var import_nativeError = require("../nativeError");
var ScreenCapture = Object.freeze({
  getState: function getState() {
    return Promise.resolve("unspecified");
  },
  captureWindow: function captureWindow() {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("ScreenCapture.captureWindow"));
  },
  captureView: function captureView(viewTag) {
    (0, import_validate.validateViewTag)(viewTag);
    return Promise.reject((0, import_nativeError.missingNativeBuild)("ScreenCapture.captureView"));
  },
  addStateListener: function addStateListener(onChange) {
    (0, import_validateCallback.validateCallback)(onChange, "ScreenCapture.addStateListener requires a function");
    return function() {
    };
  },
  addScreenshotListener: function addScreenshotListener(onScreenshot) {
    (0, import_validateCallback.validateCallback)(onScreenshot, "ScreenCapture.addScreenshotListener requires a function");
    return function() {
    };
  },
  prevent: function prevent() {
    var key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : import_validate.preventDefaultKey;
    (0, import_validate.assertPreventKey)(key, "prevent");
    return Promise.resolve();
  },
  allow: function allow() {
    var key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : import_validate.preventDefaultKey;
    (0, import_validate.assertPreventKey)(key, "allow");
    return Promise.resolve();
  },
  isPrevented: function isPrevented() {
    return Promise.resolve(false);
  }
});
function usePreventScreenCapture() {
  var key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : import_validate.preventDefaultKey;
  (0, import_validate.assertPreventKey)(key, "prevent");
  (0, import_react.useEffect)(function() {
  }, [
    key
  ]);
}
//# sourceMappingURL=unavailable.js.map
